export default __webpack_public_path__ + "4d226e278505fe10a07f2d858a759ba1.webm";